var _jsxFileName = "/codebuild/output/src449691236/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/RichText/index.tsx";
import React from 'react';
import { Trans } from 'react-i18next';
import { Text } from '@adc/parallax-component-library';
import i18n from 'Utilities/i18n';
import { getDefaultTransComponents } from './utils';
export function RichText({
  text,
  values = {},
  onPressLink,
  customNodes,
  style,
  ParentComponent,
  fontToken = '$bodyBase.default',
  testID,
  ...rest
}) {
  const defaultTransComponents = getDefaultTransComponents(onPressLink, customNodes, fontToken);
  return /*#__PURE__*/React.createElement(Trans, Object.assign({
    i18n: i18n,
    defaults: text,
    values: values,
    parent: ParentComponent ?? Text,
    type: fontToken,
    components: defaultTransComponents,
    style: style,
    id: testID,
    testID: testID
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 5
    }
  }));
}